import script from "./CardBoxSiswa.vue?vue&type=script&setup=true&lang=js"
export * from "./CardBoxSiswa.vue?vue&type=script&setup=true&lang=js"

import "./CardBoxSiswa.vue?vue&type=style&index=0&id=0bcdaed9&scoped=true&lang=css"

import exportComponent from "/var/www/html/project-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bcdaed9"]])

export default __exports__